import { TYPO } from "styles/Typo";
import { getChoicePercentage, getWiningIcon, getWinningChoice } from "../util";
import { useRouter } from "next/router";

function ClosedDiscuss({ data }: { data: any }) {
  const router = useRouter();
  const options = data?.options;
  const isEquallyVoted = data?.isEquallyVoted;
  const winingOption = data?.winningOption;
  const userWon = data?.userWon;
  const userChoice = data?.userChoice;
  const userChoiceSymbol = data?.userChoiceSymbol;
  const addWininngOptions = isEquallyVoted
    ? options?.filter((option: any) => option.votes === winingOption?.votes)
    : [];

  return (
    <div
      className="px-6 py-4 flex flex-col gap-2 cursor-pointer"
      onClick={() => {
        router.push(
          `/discuss/${
            data?.url_slug ? `${data?.url_slug}-${data?.id}` : data?.id
          }`
        );
      }}
    >
      <span
        className={`whitespace-pre-line ${TYPO.TYPO6_MD} ${
          !userChoiceSymbol ? "text-gray50" : "text-blue40"
        }`}
      >
        {/* {data.userWon === null || data.userWon === undefined
          ? "참여하지 않은 토론"
          : isEquallyVoted
          ? "비긴 토론"
          : data.userWon
          ? "내가 이긴 토론"
          : "내가 진 토론"} */}
        {!userChoiceSymbol ? "참여하지 않았어요" : "참여했어요"}
      </span>
      <span className={`whitespace-pre-line ${TYPO.TYPO5_SB} text-gray80`}>
        {data.title}
      </span>

      {winingOption && (
        <div className="flex  items-center">
          {addWininngOptions?.length > 1 && isEquallyVoted ? (
            userWon ? (
              <div className="flex gap-1 items-center">
                <div>{getWiningIcon(userChoiceSymbol)}</div>
                <span className={`${TYPO.TYPO7_MD} text-gray60`}>
                  {userChoice}
                </span>
              </div>
            ) : (
              addWininngOptions.map((option: any, index: number) => (
                <div key={index} className="flex items-center">
                  <div className="flex gap-1 items-center">
                    <div>{getWiningIcon(option?.symbol)}</div>
                    <span className={`${TYPO.TYPO7_MD} text-gray60`}>
                      {option?.value}
                    </span>
                  </div>

                  {index !== addWininngOptions.length - 1 && (
                    <div className="text-gray30 w-[1px] h-[8px] shrink-0 bg-gray30 mx-2"></div>
                  )}
                </div>
              ))
            )
          ) : (
            <div className="flex gap-1 items-center">
              {getWiningIcon(winingOption?.symbol)}
              <span className={`${TYPO.TYPO7_MD} text-gray60`}>
                {winingOption?.value}
              </span>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
{
  /* <span className={`${TYPO.TYPO7_MD} text-gray60`}>
{addWininngOptions?.length > 1 && isEquallyVoted
  ? userWon
    ? userChoice
    : addWininngOptions
        .map((option: any) => option?.value)
        .join(", ")
  : winingOption?.value}{" "}
</span> */
}
{
  /* {getChoicePercentage(data.totalVotes, winingOption?.votes)} */
}

export default ClosedDiscuss;
